import { NavigationHookAfter } from 'vue-router';
import { trackSiftPageview } from '../../lib/sift';

const siftPageviews: NavigationHookAfter = (_to, _from) => {
  try {
    trackSiftPageview();
  } catch (error) {
    console.error('Sift tracking failed:', error);
  }
};

export default siftPageviews;
